<template />
<script>
export default {
  inject: ['getMap'],
  mounted() {
    window.open(window.AppConfig.downloadUrl)
    const tabName = this.$store.state.tabName
    this.getMap(tabName)
  }
}

</script>
